/*
 * @Description:审批代理
 * @Autor: lwq
 * @Date: 2020-07-29 09:48:51
 * @LastEditors: yd
 * @LastEditTime: 2020-11-30 14:51:18
 * @FilePath: \mrc-base-server-view\src\service\api\approver.js
 */

import http from '../httpConfig'

const table = "mrbase_sys_flow_proxy_approval_type"

// 列表
export const approvertypeList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/list-approval_type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 新增
export const addApprovertype = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/add-approval_type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 删除
export const delApprovertype = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/delete-approval_type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 修改
export const updateApprovertype = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/update-approval_type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 详情
export const detailApprovertype = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/proxy_approval/find-approval_type/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}